import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';
import { ActivatedRoute, Router } from '@angular/router';
import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { filter, map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthenticationService } from '../../../services/authentication.service';
import { DashboardService } from '../../../services/dashboard.service';
import { SharedserviceService } from '../../../services/sharedservice.service'
import * as CryptoJS from 'crypto-js';
@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user = [];
  clientusername: any;
  clientname: any;
  headerClientName: any;
  regionname: any;
  regionnametip: any;
  appname = "";
  logoenable: boolean;
  regionlength: boolean;
  public role = "";
  pagepermissions: any;
  pic: any;
  imagepath = ""
  imagepath2 = ""
  headername = "";
  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';
  userMenu = [{ title: 'Reset Password' }, { title: 'Log out' }];
  //userMenu = [,{title: 'Notes'},{ title: 'Reset Password' },{ title: 'Log out' },];
  // REMenu = [{title:'User Logs'},{ title: 'Reset Password' }, { title: 'Log out' }];
  REMenu = [];
  VodafoneMenu = [];
  MsilMenu=[];
  showname: any;
  Objid: any;
  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserData,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private _AuthenticationService: AuthenticationService,
    public _DashboardService: DashboardService,
    public _SharedserviceService: SharedserviceService,
    private router: Router,) {
  }

  ngOnInit() {

    this.menuService.onItemClick()
      .pipe(
        filter(({ tag }) => tag === 'userMenuTag'),
        map(({ item: { title } }) => title),
      )
      .subscribe(title => {
        if (title == "Log out") {
          let logouttime = new Date();
          this._AuthenticationService.logouttotal(this.role, this.Objid, logouttime, this.clientusername);
        }
        else if (title == "Reset Password") {
          this.router.navigate(['/auth/reset']);
          // window.location.href = "/auth/reset";
        }
        else if (title == "Create User") {
          this.router.navigate(['/admin/users/create-user']);
          // window.location.href = '/admin/users/create-user'
        }
        else if (title == "User Logs") {
          this.router.navigate(['/admin/users/userlogs']);
          // window.location.href = '/admin/users/userlogs'
        }
        else if (title == "Logs") {
          this.router.navigate(['/admin/users/logs']);
          // window.location.href = "/admin/users/logs"
        }
        else if (title == "Notes") {
          this.router.navigate(['/admin/users/notes']);
          // window.location.href = "/admin/users/notes"
        }
      });

      this._AuthenticationService.getPermissions(localStorage.getItem('role'),localStorage.getItem('appName'),localStorage.getItem('clientIDE'))
        .subscribe(res => {
              // console.log('permission from sso in header page', res);
              const bytes = CryptoJS.AES.decrypt((<any>res).data, '!hrv7PSJxkzTy#g!+=KzsbLcmU4fW4tgZEr_4WkR');
              const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
              // console.log('Decrypted permissions', decryptedData);
              this.clientusername = localStorage.getItem('username');
          this.role = localStorage.getItem('role');
          this.appname = localStorage.getItem('appName');
               if (localStorage.getItem('role') == "EaiRM") {
              //  this._DashboardService.getRegionforEaiuser(this.clientusername)
              //    .subscribe(res => {
                    this.regionname = decryptedData[0].regions;
                    this.regionlength = (this.regionname.length > 2);
                    // this.regionnametip=this.regionname.toString()
    
                    if (this.regionname.length > 2) {
                      let regionnames = [];
                      for (let i = 0; i < 2; i++) {
                        regionnames.push(this.regionname[i]);
                      }
                      this.regionname = regionnames;
                    }
                //  })
              } else {
                // this._DashboardService.getRegionsBasedonUser(this.clientusername)
                //   .subscribe(res => {
                     this.regionname = decryptedData[0].regions
                     // this.regionnametip=this.regionname.toString()
                     this.regionlength = (this.regionname.length > 2);
                  //   if (this.regionname.length > 2) {
                       let regionnames = [];
                       for (let i = 0; i < 2; i++) {
                         regionnames.push(this.regionname[i]);
                       }
                       this.regionname = regionnames;
                  //   }
                 //  })
               }
        })


    this._AuthenticationService.getUserData()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => {
        if (users) {
          this.user = users.data;
          
          this.Objid = users.message;
        
        }
      });

 //   this._AuthenticationService.getusercontroldata(this.clientusername, this.appname)
 //     .subscribe(res => {
 //       console.log('data 1',res.data[0][0]);
 //       this.clientname = res.data[0][0].clientName
 //       localStorage.setItem('client', this.clientname);
         this.clientname = localStorage.getItem('clientIDE')
        // console.log(localStorage.getItem('clientIDE'),'client name from getusercontroledata');
        this.pagepermissions = [];
        this.getpermissions(this.pagepermissions)
        // if (this.role != "EaiRM") {
        //   this._SharedserviceService.pageLevelPermissions(this.appname, this.clientusername, localStorage.getItem('clientIDE'), "Dashboard Menu", this.role)
        //     .subscribe(res => {
        //       console.log('permissions',res.data);
        //       if (res.data == null) {
        //         this.pagepermissions = [];
        //         this.getpermissions(this.pagepermissions)
        //       } else {
        //         this.pagepermissions = res.data.pagePermission;
        //         this.getpermissions(this.pagepermissions)
        //       }
        //     },
        //       (error) => {
        //         this.pagepermissions = [];
        //         this.getpermissions(this.pagepermissions)
        //       })
        // } else {
        //   this.pagepermissions = [];
        //   this.getpermissions(this.pagepermissions)
        // }


        this.userService.getUsers()
          .pipe(takeUntil(this.destroy$))
          .subscribe((users: any) => {
            if (this.clientname == "Royal Enfield RSA") {
              this.pic = users.RE;
              this.showname = users.RE
            }
            else if (this.clientname == "Vodafone RSA") {
              this.pic = users.vodafone;
              this.showname = users.vodafone;
            }else if(this.clientname =="Maruti Suzuki"){
              this.pic = users.Msil;
              this.showname = users.Msil
            }else if(this.clientname =="Jaguar"){
              this.pic = users.jaguar;
              this.showname = users.jaguar
            }
            else if (this.clientname == "Mahindra Verito RSA") {
              this.pic = users.MHDR;
              this.showname = users.MHDR
            }
            else if (this.clientname == "MG MOTORS") {
              this.pic = users.MG;
              this.showname = users.MG
            }
            else if (this.clientname == "AtherEnergyRSA") {
              this.pic = users.AE;
              this.showname = users.AE
            } else {
              this.showname = 'CLUSTER'
            }
          }
          );
    //  })

    this.currentTheme = this.themeService.currentTheme;

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(false, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  getpermissions(pagepermissions) {
    // console.log(localStorage.getItem('clientIDE'), 'clientname')
    if (localStorage.getItem('clientIDE') == "Royal Enfield RSA" || localStorage.getItem('clientIDE') =="Jaguar" || localStorage.getItem('clientIDE') =="Mahindra Verito RSA" || localStorage.getItem('clientIDE') =="MG MOTORS" || localStorage.getItem('clientIDE') =="AtherEnergyRSA") {
      if (pagepermissions) {
        for (let i = 0; i < pagepermissions.length; i++) {
          if (pagepermissions[i].view == true) {
            this.REMenu.push({ title: pagepermissions[i].eventName })
          }
        }
        this.REMenu.push({ title: 'Reset Password' }, { title: 'Log out' })
      }
      else {
        this.REMenu = [{ title: 'Reset Password' }, { title: 'Log out' }]
      }
      this.headerClientName = this.clientname
      if(this.clientname == 'Jaguar') {
        this.headerClientName = "Jaguar/Land Rover"
      }
      if(this.clientname == 'Mahindra Verito RSA') {
        this.headerClientName = "Mahindra"
      }
      if(this.clientname == 'MG MOTORS') {
        this.headerClientName = "MG MOTORS"
      }
      if(this.clientname == 'AtherEnergyRSA') {
        this.headerClientName = "Ather Energy"
      }      
      this.userMenu = this.REMenu;
      this.logoenable = true;
      this.imagepath = "../../../../assets/images/relogo.png";
      if(this.clientname=="Jaguar"){
        this.imagepath="../../../../assets/images/jaguar_landrover_2.jpg";
        // this.imagepath2="../../../../assets/images/landrover_1.png";        
      }
      if(this.clientname=="Mahindra Verito RSA"){
        this.imagepath="../../../../assets/images/thumbnail_image001.png";
        // this.imagepath2="../../../../assets/images/landrover_1.png";        
      }
      if(this.clientname=="MG MOTORS"){
        this.imagepath="";
      }
      if(this.clientname=="AtherEnergyRSA"){
        this.imagepath="../../../../assets/images/ather.png";
      }
      this.headername = "RSA Dashboard"
    }
    else if (this.clientname == "Vodafone RSA") {
      if (pagepermissions) {
        for (let i = 0; i < pagepermissions.length; i++) {
          if (pagepermissions[i].view == true) {
            this.VodafoneMenu.push({ title: pagepermissions[i].eventName })
          }
        }
        this.VodafoneMenu.push({ title: 'Reset Password' }, { title: 'Log out' })
      }
      else {
        this.VodafoneMenu = [{ title: 'Reset Password' }, { title: 'Log out' }]
      }
      this.headerClientName = " "
      this.userMenu = this.VodafoneMenu;
      this.logoenable = true;
      this.imagepath = "../../../../assets/images/okinawalogo.png";
      this.headername = "Okinawa Dashboard"
      // this.imagepath="../../../../assets/images/vf.png"
    }
    else if(this.clientname =="Maruti Suzuki"){
      if (pagepermissions) {
        for (let i = 0; i < pagepermissions.length; i++) {
          if (pagepermissions[i].view == true) {
            this.MsilMenu.push({ title: pagepermissions[i].eventName })
          }
        }
        this.MsilMenu.push({ title: 'Reset Password' }, { title: 'Log out' })
      }
      else {
        this.MsilMenu = [{ title: 'Reset Password' }, { title: 'Log out' }]
      }
      this.headerClientName = "Maruti Suzuki"
      this.userMenu = this.MsilMenu;
      this.logoenable = true;
      this.headername = "RCU Dashboard";
    }
    else {
      if (pagepermissions) {
        for (let i = 0; i < pagepermissions.length; i++) {
          if (pagepermissions[i].view == true) {
            this.REMenu.push({ title: pagepermissions[i].eventName })
          }
        }
        this.REMenu.push({ title: 'Reset Password' }, { title: 'Log out' })
      }
      else {
        this.REMenu = [{ title: 'Reset Password' }, { title: 'Log out' }]
      }
      this.headerClientName = this.clientname
      this.headername = "RSA Dashboard"
    }
  }
}
